import clsx from 'clsx'
import {FC} from 'react'

type Props = {
  data: number
}

const HrItemValue: FC<Props> = ({data}) => {
  return (
    <div className={clsx('d-flex justify-content-center', {'text-gray-700': data === 0}, {'text-gray-900': data > 0})}>
      {data}
    </div>
  )
}

export {HrItemValue}
